import { useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { useInterval } from './useWindowInterval';

const interval = 1500;

export const usePleaseStay = (isActive: boolean): void => {
  const { t } = useTranslation();

  // State vars
  const titleIndexRef = useRef<number>(0);

  // Ref vars - lazy initialization to capture original title
  const originalDocumentTitle = useRef<string>(undefined);
  const prevIsActive = useRef<boolean>(isActive);

  // Lazy initialization of original document title
  if (originalDocumentTitle.current === undefined) {
    originalDocumentTitle.current = document.title;
  }

  const titles = [originalDocumentTitle.current, t('conversation.you_have_unread_messages')];

  // The logic to restore default title and favicon.
  const restoreDefaults = () => {
    titleIndexRef.current = 0;
    setTimeout(() => {
      if (originalDocumentTitle.current) {
        document.title = originalDocumentTitle.current;
      }
    }, interval);
  };

  const modifyDocumentTitle = () => {
    // Check if isActive state changed
    if (prevIsActive.current !== isActive) {
      prevIsActive.current = isActive;

      if (!isActive) {
        restoreDefaults();
        return;
      } else {
        titleIndexRef.current = 0;
      }
    }

    // Only animate if active
    if (!isActive) {
      return;
    }

    document.title = titles[titleIndexRef.current];
    titleIndexRef.current =
      titleIndexRef.current === titles.length - 1 ? 0 : titleIndexRef.current + 1;
  };

  // Change title and favicon at specified interval
  useInterval(
    () => {
      modifyDocumentTitle();
    },
    isActive ? interval : null
  );
};
